module.exports = __webpack_public_path__ + "media/images/common/logo_bg_04-ca1492f5a1914d1888ff7d251529d3e8.png";